import { findInPersistentStore, storePersistent } from '@lumapps/cache/api/persistentStore';
import { generateUUID } from '@lumapps/utils/string/generateUUID';

import { LUMAPPS_PUBLIC_UNIQUE_ID } from '../constants';
/**
 * Get and set LUMAPPS_PUBLIC_UNIQUE_ID in local storage.
 * It should be used for analytics purpose, for non-connected users.
 * Use localStorage.setItem/localStorage.getItem instead of cache utils
 * Because we do not want the value to be stringified or parsed
 */
export const getLumappsPublicUniqueId = () => findInPersistentStore(LUMAPPS_PUBLIC_UNIQUE_ID);

export const setLumappsPublicUniqueId = () => storePersistent(LUMAPPS_PUBLIC_UNIQUE_ID, generateUUID());
